import HeaderSection from "../components/Header"
import NavigationBar from "../components/NavigationBar"
import Footer from "../components/Footer"
import ItemCard from "../components/ItemCard"


import MbToken from "../assets/mbtoken.svg"
import Meta from "../assets/metamask-white.svg"
import Opensea from "../assets/opensea.svg"
import NftFrame from "../assets/nft-frame.png"

import Image1 from "../assets/frame1.png"
import Image2 from "../assets/frame2.png"
import Image3 from "../assets/frame3.png"
import Image4 from "../assets/frame4.png"
import Image5 from "../assets/frame5.png"
import Image6 from "../assets/frame6.png"
import Image7 from "../assets/frame7.png"
import Image8 from "../assets/frame8.png"

const IndexPage = () => {

    return (
        <div>
            <div className="container mx-auto max-w-[80%] mt-2" >
                <NavigationBar />

                <HeaderSection />
            </div>

            <div className="flex md:flex-row bg-[#A02276] justify-center py-2 ">
                <img className="lg:px-40 md:px-10 py-1 icon" src={MbToken} alt="token" />
                <img className="lg:px-40 md:px-10 py-1 icon" src={Meta} alt="token" />
                <img className="lg:px-40 md:px-10 py-1 icon" src={Opensea} alt="token" />
            </div>

            <div className="font-redrose my-20">
                <div className="container mx-auto md:justify-center max-w-[80%]">
                    <h3 className="font-semibold text-center md:text-5xl text-2xl">Inspiration for your next adventure</h3>

                    <div className="mt-10 grid lg:grid-cols-4 md:grid-cols-2 gap-8">
                        <ItemCard imageSrc={Image1} />
                        <ItemCard imageSrc={Image2} />
                        <ItemCard imageSrc={Image3} />
                        <ItemCard imageSrc={Image4} />
                        <ItemCard imageSrc={Image5} />
                        <ItemCard imageSrc={Image6} />
                        <ItemCard imageSrc={Image7} />
                        <ItemCard imageSrc={Image8} />
                    </div>

                </div>
            </div>


            <div className="bg-[#A02276] py-2 font-redrose">
                <div className="container mx-auto max-w-[80%] my-2 md:justify-between flex lg:flex-row flex-col" >
                    <div className="lg:w-2/5 text-left text-[26px] text-white md:text-6xl lg:my-40  my-10 font-semibold flex-col">
                        <h2 className="mt-6 py-6">Metabnb NFTs</h2>

                        <p className="md:text-xl text-sm my-4 md:leading-9 font-normal">Discover our NFT gift cards collection. Loyal customers gets amazing gift cards which are traded as NFTs. These NFTs gives our customer access to loads of our exclusive services.</p>

                        <button className="bg-white text-[#A02276] my-10 font-normal md:text-xl text-sm">Learn More</button>
                    </div>
                    {/* <div className="md:w-1/5"></div> */}
                    <div className="lg:w-3/5 lg:my-20 mb-10 md:ml-[6em]">
                        <img className="py-1" src={NftFrame} alt="nft" />
                    </div>
                </div>
            </div>

            <Footer />

        </div>
    )
}

export default IndexPage